export const ACCORDION_PANEL_MEASUREMENTS = "measurements"